// IANA time-zone helpers for the club registration form.

export function getTimeZones(): string[] {
  // Intl.supportedValuesOf is ES2022; our TS lib target is ES2020, hence the
  // typed access. Every browser this app targets ships it, so the only fallback
  // we need is the user's own zone.
  const intl = Intl as typeof Intl & {
    supportedValuesOf?: (key: string) => string[]
  }
  if (typeof intl.supportedValuesOf === 'function') {
    return intl.supportedValuesOf('timeZone')
  }
  return [getDefaultTimeZone()]
}

export function getDefaultTimeZone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC'
  } catch {
    return 'UTC'
  }
}
